export default {
    imageAIFormRules: {
        enterDescription: 'Indtast venligst beskrivelsen',
        invalidDescription: 'Indtast venligst en gyldig beskrivelse',
        enterNumberOfVariations: 'Vælg venligst antallet af variationer',
        invalidNumberOfVariations: 'Du kan generere maksimalt 4 og mindst 1 variation',
        enterStyle: 'Vælg venligst mindst én stilart',
    },
};
